export function buildCumulativeRegistrationsOverTime(
    registrations: { dateTime: string | Date }[]
): { date: string; count: number }[] {
    const dateMap = new Map<string, number>();

    [...registrations]
        .sort((a, b) => new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime())
        .forEach((reg) => {
            const dateStr = new Date(reg.dateTime).toLocaleDateString("en-US");
            dateMap.set(dateStr, (dateMap.get(dateStr) || 0) + 1);
        });

    let cumulativeCount = 0;
    return Array.from(dateMap.entries()).map(([date, count]) => {
        cumulativeCount += count;
        return { date, count: cumulativeCount };
    });
}

export function formatRegistrationDateTick(dateValue: string): string {
    const parsedDate = new Date(dateValue);
    if (Number.isNaN(parsedDate.getTime())) {
        return dateValue;
    }

    return parsedDate.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
    });
}
